import { render, staticRenderFns } from "./PunchTagInput.vue?vue&type=template&id=43495153"
import script from "./PunchTagInput.vue?vue&type=script&lang=ts"
export * from "./PunchTagInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports